import { render, staticRenderFns } from "./FlightSelectTravelType.vue?vue&type=template&id=156c250f&scoped=true&"
import script from "./FlightSelectTravelType.vue?vue&type=script&lang=js&"
export * from "./FlightSelectTravelType.vue?vue&type=script&lang=js&"
import style0 from "./FlightSelectTravelType.vue?vue&type=style&index=0&id=156c250f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156c250f",
  null
  
)

/* custom blocks */
import block0 from "./FlightSelectTravelType.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
